import {Component} from 'react';
import Glob from "../../libs/Glob.mjs";

const MainMenu = class extends Component{

	componentDidMount() {
		Glob.setStatus('pageTitle', 'MainMenu');
		Glob.setStatus('pageIcon');
		setTimeout( ()=>{ Glob.setStatus('slider', true )}, 300);
	}

	componentWillUnmount() {
		Glob.setStatus('pageTitle');
	}

	render(){
		return null;
	}
}

export default MainMenu;